import React from "react";
import { Link } from "gatsby";

function Button({
  children,
  linkTo,
  className,
  onClick,
  type,
  btnIcon,
  isExternal,
  ...rest
}) {
  return (
    children && (
      <>
        {!type &&
          (isExternal ? (
            <a
              href={linkTo}
              className={`btn ${className}`}
              target="_blank"
              rel="noreferrer"
            >
              {children}
            </a>
          ) : (
            <Link to={linkTo} onClick={onClick} className={`btn ${className}`}>
              {children}
            </Link>
          ))}
        {type && (
          <button onClick={onClick} className={`btn ${className}`} {...rest}>
            {children}
          </button>
        )}
      </>
    )
  );
}

export default Button;
